import React from "react";
import { useResource, useNavigation } from "@refinedev/core";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Pencil } from "lucide-react";
import { Spinner } from "@/components/ui/spinner";
import { PageHeader } from "@/components/ui/page-header";

interface ShowPageProps {
  title?: string;
  children: React.ReactNode;
  isLoading?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  headerButtons?: React.ReactNode;
}

export const ShowPage: React.FC<ShowPageProps> = ({
  title,
  children,
  isLoading,
  canEdit = true,
  headerButtons,
}) => {
  const { resource, id } = useResource();
  const { goBack, edit } = useNavigation();
  const displayTitle = title || resource?.meta?.label || resource?.name || "";

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title={
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={goBack} className="-ml-2">
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <span>{displayTitle}</span>
          </div>
        }
        actions={
          <div className="flex items-center gap-2">
            {headerButtons}
            {canEdit && id && (
              <Button variant="outline" onClick={() => edit(resource?.name ?? "", id)}>
                <Pencil className="mr-2 h-4 w-4" />
                Edit
              </Button>
            )}
          </div>
        }
      />
      {children}
    </div>
  );
};
